import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

// env
import { environment } from '../../../environments/environment';

// Plugin
import { ModalDirective } from 'ngx-bootstrap/modal';
import Swal from 'sweetalert2';

// Service
import { ApiService } from '../../shared/service/api.service';

@Component({
  selector: 'app-widget-pdf',
  templateUrl: './widget-pdf.component.html',
  styles: [
  ]
})
export class WidgetPdfComponent implements OnInit {

  @ViewChild('modal', { static: false }) modal: ModalDirective;
  @Input() dataWidgetPdf;
  @Input() isActive;
  isModalShown = false;
  dataFile;
  apiAsset = environment.API_ASSETS;
  userDwn;

  constructor( private apiService: ApiService ) { }

  ngOnInit(): void {
    this.userDwn =  window.localStorage.getItem("userDownload");
  }

  onSubmit(pdfForm: NgForm) {
    let body = pdfForm.value;
    if(body.name && body.email){
      this.apiService.postDataApi('downloadLog', body).subscribe(
        data => { 
          this.onHidden();
          window.open(this.apiAsset + this.dataFile.filename, "_blank");
          // Check browser support Local Storage
          if (typeof(Storage) !== "undefined") {
            // Store
            window.localStorage.setItem("userDownload", body);
            this.userDwn = window.localStorage.getItem("userDownload");
          }
        },
        error => { 
          Swal.fire({
            icon: 'error',
            text: 'Failed, please try again!'
          });
          this.onHidden();
        }
      ); 
      pdfForm.resetForm();
    }
  }

  showModal(data): void {
    this.dataFile = data;
    if(this.isActive == 1 && this.userDwn == null){
      this.isModalShown = true;
    }else{
      window.open(this.apiAsset + this.dataFile.filename, "_blank");
    }
  }

  onHidden(): void {
    this.isModalShown = false;
  }
}
